























































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ApiResponse } from '@/components/types';
import { REGISTER_ADMINISTRATOR } from '@/modules/employee/store';
import { RegisterJuniorAdministrator } from '@/modules/employee/types';
import { createJuniorAdministrator } from '@/modules/employee/admin/models';
import SalutationSelect from '@/modules/conservatorship/components/SalutationSelect.vue';

const Employee = namespace('employee');

@Component({
  components: {
    SalutationSelect
  }
})
export default class JuniorAdministratorForm extends Vue {
  @Employee.Action(REGISTER_ADMINISTRATOR) register!: (params: RegisterJuniorAdministrator) => Promise<ApiResponse>;

  error: any = null;
  loading: boolean = false;

  value: RegisterJuniorAdministrator = createJuniorAdministrator();

  reset(observer?: any) {
    this.error = null;
    this.value = createJuniorAdministrator();
    observer && observer.reset();
  }

  cancel(observer?: any) {
    this.reset(observer);
    this.$emit('cancel');
  }

  back(observer: any) {
    this.reset(observer);
    this.$emit('back');
  }

  save() {
    this.error = null;

    return this.register(this.value);
  }
}
